import './_jquery';

jQuery(function() {
  let add_marker, center_map, new_map, styled_map;

  new_map = function($el) {
    let $markers, args, map, styledMapType;

    $markers = $el.find('.google-map__box__marker');
    styledMapType = styled_map();
    args = {
      scrollwheel: false,
      zoom: 16,
      center: new google.maps.LatLng(0, 0),
      mapTypeControl: false,
      streetViewControl: false
    };

    // Create map
    map = new google.maps.Map($el[0], args);
    map.mapTypes.set('styled_map', styledMapType);
    map.setMapTypeId('styled_map');

    // Add markers
    map.markers = [];
    $markers.each(function() {
      add_marker($(this), map);
    });

    // Center map
    center_map(map);
    return map;
  };

  center_map = function(map) {
    let bounds, latlng;

    bounds = new google.maps.LatLngBounds;

    $.each(map.markers, function(i, marker) {
      let latlng;
      latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
      return bounds.extend(latlng);
    });

    if (map.markers.length === 0) {
      latlng = new google.maps.LatLng(42.177174, 12.035745);
      map.setCenter(latlng);
      map.setZoom(5);
    } else if (map.markers.length === 1) {
      map.setCenter(bounds.getCenter());
      map.setZoom(12);
    } else {
      map.fitBounds(bounds);
    }
  };

  add_marker = function($marker, map) {
    let image, infowindow, latlng, marker;

    if ($marker.attr('data-lng')) {
      latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

      image = {
        url: $marker.attr('data-marker-url'),
        scaledSize: new google.maps.Size(22, 31)
      };

      marker = new google.maps.Marker({
        position: latlng,
        map: map,
        icon: image
      });

      marker.addListener('click', function() {
        infowindow.open(map, marker);
      });

      map.markers.push(marker);

      if ($marker.html()) {
        infowindow = new google.maps.InfoWindow({
          content: $marker.html()
        });
        google.maps.event.addListener(marker, 'click', function() {
          infowindow.open(map, marker);
        });
      }
    }
  };

  $(document).ready(function() {
    $('.google-map__box').each(function() {
      new_map($(this));
    });
  });

  styled_map = function() {
    let styledMapType;
    styledMapType = new google.maps.StyledMapType([
      {
        featureType: 'all',
        elementType: 'labels.text',
        stylers: [
          {
            'visibility': 'off'
          }, {
            'gamma': '3.29'
          }
        ]
      }, {
        featureType: 'administrative',
        elementType: 'all',
        stylers: [
          {
            'visibility': 'on'
          }, {
            'gamma': '0.20'
          }
        ]
      }, {
        featureType: 'administrative.country',
        elementType: 'geometry.stroke',
        stylers: [
          {
            'visibility': 'on'
          }
        ]
      }, {
        featureType: 'administrative.country',
        elementType: 'labels.text',
        stylers: [
          {
            'visibility': 'off'
          }, {
            'gamma': '0.00'
          }
        ]
      }, {
        featureType: 'administrative.province',
        elementType: 'geometry.stroke',
        stylers: [
          {
            'visibility': 'on'
          }, {
            'gamma': '0.00'
          }, {
            'color': '#333333'
          }
        ]
      }, {
        featureType: 'administrative.province',
        elementType: 'labels.text',
        stylers: [
          {
            'visibility': 'on'
          }, {
            'gamma': '0.00'
          }
        ]
      }, {
        featureType: 'administrative.locality',
        elementType: 'labels.text',
        stylers: [
          {
            'visibility': 'on'
          }, {
            'gamma': '0.20'
          }
        ]
      }, {
        featureType: 'landscape',
        elementType: 'all',
        stylers: [
          {
            'color': '#5a5a5a'
          }, {
            'visibility': 'off'
          }
        ]
      }, {
        featureType: 'landscape.man_made',
        elementType: 'geometry.fill',
        stylers: [
          {
            'color': '#d7d7d7'
          }, {
            'visibility': 'on'
          }
        ]
      }, {
        featureType: 'landscape.natural',
        elementType: 'geometry.fill',
        stylers: [
          {
            'color': '#e4e3df'
          }, {
            'visibility': 'on'
          }
        ]
      }, {
        featureType: 'poi',
        elementType: 'labels.icon',
        stylers: [
          {
            'visibility': 'off'
          }
        ]
      }, {
        featureType: 'poi.attraction',
        elementType: 'all',
        stylers: [
          {
            'visibility': 'off'
          }
        ]
      }, {
        featureType: 'poi.business',
        elementType: 'all',
        stylers: [
          {
            'visibility': 'off'
          }
        ]
      }, {
        featureType: 'poi.government',
        elementType: 'geometry',
        stylers: [
          {
            'visibility': 'off'
          }
        ]
      }, {
        featureType: 'poi.medical',
        elementType: 'all',
        stylers: [
          {
            'visibility': 'off'
          }
        ]
      }, {
        featureType: 'poi.park',
        elementType: 'all',
        stylers: [
          {
            'color': '#91b65d'
          }, {
            'gamma': '1.51'
          }
        ]
      }, {
        featureType: 'poi.park',
        elementType: 'labels.icon',
        stylers: [
          {
            'visibility': 'off'
          }
        ]
      }, {
        featureType: 'poi.place_of_worship',
        elementType: 'all',
        stylers: [
          {
            'visibility': 'off'
          }
        ]
      }, {
        featureType: 'poi.school',
        elementType: 'all',
        stylers: [
          {
            'visibility': 'off'
          }
        ]
      }, {
        featureType: 'poi.sports_complex',
        elementType: 'all',
        stylers: [
          {
            'visibility': 'off'
          }
        ]
      }, {
        featureType: 'poi.sports_complex',
        elementType: 'geometry',
        stylers: [
          {
            'color': '#c7c7c7'
          }, {
            'visibility': 'off'
          }
        ]
      }, {
        featureType: 'road',
        elementType: 'all',
        stylers: [
          {
            'color': '#ffffff'
          }
        ]
      }, {
        featureType: 'road',
        elementType: 'labels',
        stylers: [
          {
            'visibility': 'off'
          }
        ]
      }, {
        featureType: 'road',
        elementType: 'labels.text',
        stylers: [
          {
            'visibility': 'off'
          }, {
            'gamma': '1.00'
          }, {
            'color': '#000000'
          }, {
            'weight': '1'
          }
        ]
      }, {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [
          {
            'color': '#ffffff'
          }, {
            'visibility': 'simplified'
          }
        ]
      }, {
        featureType: 'road.highway',
        elementType: 'labels.text',
        stylers: [
          {
            'visibility': 'on'
          }, {
            'color': '#737272'
          }, {
            'weight': '0.5'
          }
        ]
      }, {
        featureType: 'road.highway',
        elementType: 'labels.icon',
        stylers: [
          {
            'color': '#ffffff'
          }, {
            'visibility': 'off'
          }
        ]
      }, {
        featureType: 'road.arterial',
        elementType: 'all',
        stylers: [
          {
            'visibility': 'simplified'
          }, {
            'color': '#ffffff'
          }
        ]
      }, {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [
          {
            'visibility': 'simplified'
          }
        ]
      }, {
        featureType: 'road.arterial',
        elementType: 'labels.text',
        stylers: [
          {
            'visibility': 'on'
          }, {
            'color': '#525252'
          }, {
            'weight': '0.5'
          }
        ]
      }, {
        featureType: 'road.local',
        elementType: 'all',
        stylers: [
          {
            'color': '#ffffff'
          }, {
            'visibility': 'simplified'
          }
        ]
      }, {
        featureType: 'road.local',
        elementType: 'geometry',
        stylers: [
          {
            'visibility': 'on'
          }
        ]
      }, {
        featureType: 'road.local',
        elementType: 'labels.text',
        stylers: [
          {
            'visibility': 'on'
          }, {
            'color': '#1c1c1c'
          }, {
            'weight': '0.4'
          }
        ]
      }, {
        featureType: 'transit',
        elementType: 'all',
        stylers: [
          {
            'visibility': 'off'
          }
        ]
      }, {
        featureType: 'water',
        elementType: 'all',
        stylers: [
          {
            'color': '#a0d3d3'
          }
        ]
      }
    ], {
      name: 'Styled Map'
    });
    return styledMapType;
  };
});
